export const DEFAULT_OTP_LENGTH = 6;
